function initHeaderSearch(wrapper, openBtn, clearBtn, input) {
  const form = wrapper.querySelector('form');
  const siteHeader = document.getElementById('siteHeader');

  function pinFormBelowHeader() {
    if (window.innerWidth < 768 && siteHeader) {
      form.style.top = siteHeader.getBoundingClientRect().bottom + 'px';
    }
  }

  function open() {
    pinFormBelowHeader();
    wrapper.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      input.focus();
    });
  }

  function close() {
    wrapper.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    input.value = '';
    clearBtn.classList.remove('is-visible');
  }

  openBtn.addEventListener('click', function () {
    if (wrapper.classList.contains('is-open')) {
      close();
    } else {
      open();
    }
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.classList.remove('is-visible');
    input.focus();
  });

  input.addEventListener('input', function () {
    clearBtn.classList.toggle('is-visible', input.value.length > 0);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrapper.classList.contains('is-open')) close();
  });

  document.addEventListener('click', function (e) {
    if (wrapper.classList.contains('is-open') && !wrapper.contains(e.target)) close();
  });
}
